export default __webpack_public_path__ + "static/jetson_vehicle_rotation_desktop-408c3cc1be3c8362363f7f0db0bda7a3.png";